export default "__VITE_ASSET__CWtmEHpC__"